// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a[data-v-ddbebe50]{fill:#24bf77}.b[data-v-ddbebe50]{fill:#7ac6a3}.c[data-v-ddbebe50]{fill:#f5f5f5}.d[data-v-ddbebe50]{fill:#fff3e7}.e[data-v-ddbebe50]{fill:#eee3d8}.f[data-v-ddbebe50]{fill:#3f3f3f;font-size:35px;font-family:SegoeUI-Semibold,Segoe UI;font-weight:600}", ""]);
// Exports
module.exports = exports;
